<mat-list-item [lines]="3" >
    <mat-progress-spinner matListItemIcon *ngIf="layer.status === 'pending'" mode="indeterminate"
                          diameter="24"></mat-progress-spinner>

    <mat-icon matListItemIcon *ngIf="layer.status === 'valid' && !isWarning" class="success">check_circle</mat-icon>
    <mat-icon matListItemIcon *ngIf="isWarning" class="warning">help</mat-icon>
    <mat-icon matListItemIcon *ngIf="layer.status === 'error'" class="error">cancel</mat-icon>

  <div matListItemTitle class="mb-2">
      <mat-form-field class="form-small w-100">
          <input matInput
                  [(ngModel)]="layer.layerName"
                  #nameInput="ngModel"
          />
          @if (!layer.layerName.length &&(nameInput.touched || nameInput.dirty)){
              <mat-error>Layer name cannot be empty</mat-error>
          }
          <mat-hint >Features: {{ layer.summary?.totalFeatures || 0 }} {{ layer.summary?.invalidFeatures > 0 ? "| Invalid: " + layer.summary?.invalidFeatures : "" }}
          </mat-hint>
      </mat-form-field>


  </div>

  @if (layer.errorMessages?.length) {
      <div matListItemLine class="summary-errors">
        @for (msg of uniqueErrorMessages; track msg) {
        <span>
          - {{ msg }}
          <br />
        </span>
        }
      </div>
  }
@if(layer.status !== 'pending'){
      <button matIconButton matListItemMeta (click)="removeLayer()">
        <mat-icon>delete_outline</mat-icon>
      </button>
  }
</mat-list-item>
